module.exports = __webpack_public_path__ + "static/bi-slider4-5e951472d523c41106ecf53d9fede148.jpeg";